import { TabNames } from '@enums/TabNames';
import { CustomCellSalespersonComponent } from '@shared/grids/custom-cell-salesperson/custom-cell-salesperson.component';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

export const COMPANIES_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'id',
        field: 'id',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/companies-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'name',
        field: 'name',
        headerName: 'Name',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'fullAddress',
        field: 'fullAddress',
        headerName: 'Main Office Address',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor',
        sortable: false
    },
    {
        colId: 'contactFirstName',
        field: 'contactFirstName',
        headerName: 'Main Contact',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'companyTypeName',
        field: 'companyTypeName',
        headerName: 'Type',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'markets',
        field: 'markets',
        headerName: 'Markets',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'companySalespersons',
        field: 'companySalespersons',
        headerName: 'Salesperson',
        cellRenderer: CustomCellSalespersonComponent
    },
    {
        colId: 'isActive',
        field: 'isActive',
        headerName: 'Condition',
        valueFormatter: (params: any) => {
            return params.value ? 'Active' : 'Archived';
        }
    }
];
